import {useContext, useState} from 'react';
import escape from 'lodash/escape';
import {Item} from 'react-photoswipe-gallery';
import FormContext from '../form-context';
import {getPreviewSrc} from './uploader/uploader-utils';
import {cleanLabel} from './action-input';
import {getGalleryCategoryId, getGalleryImage, hasGalleryText} from './gallery-items';

export default function GalleryItemSummary({item, index, categories, fileUploadSettings}) {
    const context = useContext(FormContext);
    const settings = (typeof fileUploadSettings === 'function' ? fileUploadSettings(item) : fileUploadSettings)
        || context.fileUploadSettings;
    const source = getGalleryImage(item);
    const original = getPreviewSrc(settings?.cdnUrl, {key: source}, {width: 1680, quality: 88});
    const thumbnail = getPreviewSrc(settings?.cdnUrl, {key: source});
    const [dimensions, setDimensions] = useState({width: 1680, height: 1680});
    const category = categories?.find(category => category.id === getGalleryCategoryId(item.category));
    const caption = typeof item.title === 'string' ? item.title.trim() : '';
    const description = hasGalleryText(item.text) ? item.text : '';
    const heading = [category?.title, caption].filter(Boolean).map(escape).join(' / ');
    const lightboxCaption = heading + (description
        ? `<div class="rich-text gallery-editor-lightbox-description">${description}</div>` : '');

    return <span className="gallery-editor-summary">
        {source ? <Item original={original} thumbnail={thumbnail} width={dimensions.width} height={dimensions.height}
                         title={lightboxCaption}>
            {({ref, open}) => <button ref={ref} type="button" className="gallery-editor-thumbnail"
                aria-label={`Preview Image ${index + 1}`} title="Preview Image"
                onClick={event => {event.stopPropagation(); open(event);}}
                onLoadCapture={event => {
                    const image = event.target;
                    if (image.naturalWidth > 0 && image.naturalHeight > 0) {
                        setDimensions(previous => previous.width === image.naturalWidth && previous.height === image.naturalHeight
                            ? previous : {width: image.naturalWidth, height: image.naturalHeight});
                    }
                }}>
                <img src={thumbnail} alt={item.altText || ''} draggable={false} className="w-full h-full object-contain"/>
            </button>}
        </Item> : <span className="gallery-editor-thumbnail gallery-editor-no-image text-xs font-normal text-gray-500">No Image</span>}
        <button type="button" className="gallery-editor-metadata" aria-label={`Edit Item ${index + 1}`} title="Edit Details">
            <span title={caption || 'No Caption'} className={`gallery-editor-caption text-sm ${caption ? 'font-semibold' : 'font-normal text-gray-500'}`}>
                {caption || 'No Caption'}
            </span>
            {category ? <span className="gallery-editor-snippet text-xs font-normal text-gray-500">{category.title}</span> : null}
            {description ? <span className="gallery-editor-snippet text-xs font-normal text-gray-500">{cleanLabel(description)}</span> : null}
        </button>
    </span>;
}
